import { render, staticRenderFns } from "./CompanyReportDetail.vue?vue&type=template&id=20fb421a"
import script from "./CompanyReportDetail.vue?vue&type=script&lang=js"
export * from "./CompanyReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports